import * as React from "react";
import { Controller } from "react-hook-form";
import { Label } from "../../../components/ui/label";
import { CalendarIcon, ClockIcon } from "lucide-react";
import { FieldError } from "./FieldError";
import { Button } from "../../../components/ui/button";
import { Calendar } from "../../../components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../components/ui/popover";
import { cn } from "../../../helpers/cn";

export function DatePicker({
  control,
  open,
  setOpen,
  label,
  disabled,
  className,
  name,
  step,
  startMonth,
  endMonth,
  quickToday = false,
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div>
          <div className={cn("flex flex-col gap-3", className)}>
            <Label htmlFor="date" className="px-1">
              {label}
            </Label>

            <div className="flex items-center gap-1">
              {/* Popover date trigger */}
              <Popover
                open={open}
                onOpenChange={(v) => {
                  setOpen(v);
                }}
              >
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    id="date"
                    type="button"
                    className="w-full justify-between font-normal"
                  >
                    {field.value
                      ? field.value.toLocaleDateString()
                      : "Select date"}
                    <CalendarIcon className="ml-2 h-4 w-4" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent
                  className="w-auto overflow-hidden p-0"
                  align="start"
                >
                  <Calendar
                    mode="single"
                    selected={field.value}
                    className="min-w-60 min-h-72 overflow-auto"
                    captionLayout="dropdown"
                    onSelect={(date) => {
                      field.onChange(date);
                      setOpen(false);
                    }}
                    disabled={disabled}
                    startMonth={startMonth}
                    endMonth={endMonth}
                    defaultMonth={field.value || endMonth || new Date()}
                  />
                </PopoverContent>
              </Popover>

              {/* Separate Today icon button (not inside trigger) */}
              {quickToday && (
                <Button
                  type="button"
                  variant="outline"
                  className="px-2"
                  onClick={() => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    field.onChange(today);
                  }}
                  title="Set to Today"
                >
                  <ClockIcon className="h-4 w-4" />
                </Button>
              )}
            </div>
          </div>
          <FieldError name={name} step={step} />
        </div>
      )}
    />
  );
}
